import React, { Component } from 'react'
import './home.css'
import {Link} from 'react-router-dom'

export class home3 extends Component {
    render() {
        return (
            <div className="home-3-con">     
             <div className={this.props.home3Sec}>
                 <div id="home-3-img-div">
               <img className="home-3-img" id={this.props.imgid} alt="des" src={this.props.home3Img}/> 
                </div>
                <div className="home-3-text-box">
                <h2 className="home-3-title">{this.props.home3Title}</h2>
                <p className="home-3-text">{this.props.home3Text}</p>
                <Link id="menu-link-2" to="/products"> <button className="home-3-btn">Shop</button> </Link>   
                </div>     
             </div>



            </div>
        )
    }
}
 
export default home3
